@use "../../styles/breakpoint.module.scss" as *;

.region {
    position: fixed;
    bottom: var(--spacer-24);
    right: var(--spacer-24);
    display: flex;
    flex-direction: column;
    gap: var(--spacer-8);
    z-index: 200;
    outline: 0;

    @media ($below-mobile) {
        left: var(--spacer-16);
        right: var(--spacer-16);
        bottom: var(--spacer-16);
    }
}

.toast {
    display: flex;
    align-items: center;
    gap: var(--spacer-16);
    min-width: 280px;
    max-width: 420px;
    padding: var(--spacer-16) var(--spacer-24);
    background-color: var(--black);
    color: var(--white);
    box-shadow: 0 4px 12px rgb(0 0 0 / 20%);

    @media ($below-mobile) {
        min-width: 0;
        width: 100%;
    }
}

.content {
    flex: 1;
}

.title {
    font: var(--font-p-16);
}

.close {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--spacer-24);
    height: var(--spacer-24);
    color: inherit;

    svg {
        width: 100%;
        height: 100%;
        fill: currentColor;
    }
}
